if (!customElements.get('price-range')) {
  class PriceRange extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.minNumberInput = document.getElementById('price-range-number-min');
      this.maxNumberInput = document.getElementById('price-range-number-max');
      this.minSliderInput = document.getElementById('price-range-slider-min');
      this.maxSliderInput = document.getElementById('price-range-slider-max');
      this.minValue = Number(this.minNumberInput.min);
      this.maxValue = Number(this.maxNumberInput.max);
      this.timeout = null;
      this.addEventListener('input', this.handleInput.bind(this));
    }

    /**
     * Handles 'input' events on the price range component.
     * @param {object} evt - Event object.
     */
    handleInput(evt) {
      if (evt.detail !== undefined) {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.updateSliderInputs(evt);
          this.updateNumberInputs(evt);
        }, 500);
      } else {
        this.updateSliderInputs(evt);
        this.updateNumberInputs(evt);
      }
    }

    /**
     * Updates the value of the 'number' type inputs.
     * @param {object} evt - Event object.
     */
    updateNumberInputs(evt) {
      // Never overwrite the field the user is typing in.
      if (evt.target !== this.minNumberInput) {
        this.minNumberInput.value = this.minSliderInput.value !== this.minNumberInput.min
          ? this.minSliderInput.value : null;
      }

      if (evt.target !== this.maxNumberInput) {
        this.maxNumberInput.value = this.maxSliderInput.value !== this.maxNumberInput.max
          ? this.maxSliderInput.value : null;
      }
    }

    /**
     * Updates the value of the 'range' type inputs.
     * @param {object} evt - Event object.
     */
    updateSliderInputs(evt) {
      // Sliders mirror whatever is typed - no min/max gap enforcement.
      if (evt.target === this.minNumberInput) {
        this.minSliderInput.value = parseInt(this.minNumberInput.value, 10) || Number(this.minNumberInput.min);
      }

      if (evt.target === this.maxNumberInput) {
        this.maxSliderInput.value = parseInt(this.maxNumberInput.value, 10) || Number(this.maxNumberInput.max);
      }
    }
  }

  customElements.define('price-range', PriceRange);
}
